import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { StatusType } from '@/enums/statusType.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentHistoryRoute: RouteConfig = {
  name: 'documentHistory',
  path: 'history',
  component: () => import(/* webpackChunkName: "DocumentHistory" */ '@/views/mainRoute/document/details/History.vue'),
  meta: {},
  beforeEnter: (to, from, next) =>
    Promise.all([
      store
        .dispatch('history/list', { tableName: 'document', entityId: to.params.documentId.toString(), count: -1 })
        .catch(err => store.dispatch('notifyError', { title: Errors.HISTORY_CANNOT_LIST })),
      store
        .dispatch('status/list', {
          count: -1,
          procedureId: tryParseInt(to.params.procedureId),
          type: StatusType.DOCUMENT
        })
        .catch(err => store.dispatch('notifyError', { title: Errors.STATUS_CANNOT_LIST }))
    ]).then(() => next())
};
